import { render, staticRenderFns } from "./DovizKur.vue?vue&type=template&id=35f9ca89"
import script from "./DovizKur.vue?vue&type=script&lang=ts"
export * from "./DovizKur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports